import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link, useLocation } from 'react-router-dom'
import { bottomNav } from '../utils/bottomNav'
import { navDirections } from '../utils/navDirections'
import BottomNavIcons from './BottomNavIcons'

function BottomNav() {
    const location = useLocation()
    const [value, setValue] = useState(0)
    const colors = {
        tab: '#DDDDFA',
        active: '#FE45C3'
    }

    useEffect(() => {
        if (location.pathname === navDirections.HOME) setValue(0)
        else if (location.pathname === navDirections.ONLINE_CLASS) setValue(1)
        else if (location.pathname === navDirections.HOME) setValue(2)
        else setValue(3)
    }, [location.pathname])

    return (
        <FixedBottomContainer>
            <BottomNavigation>
                {bottomNav.map((item, key) => (
                    <Link to={item.dest} key={key}>
                        <BottomNavButton>
                            <BottomNavIcons
                                color={
                                    key === value ? colors.active : colors.tab
                                }
                                nav={item.icon}
                            />
                            <BottomNavText active={key === value}>
                                {item.text}
                            </BottomNavText>
                        </BottomNavButton>
                    </Link>
                ))}
            </BottomNavigation>
        </FixedBottomContainer>
    )
}

const FixedBottomContainer = styled.div`
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    background-color: #373856;
`

const BottomNavigation = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 1.5rem;
    max-width: 800px;
    margin: auto;
    a {
        text-decoration: none;
        outline: none;
    }
`

const BottomNavButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`
const BottomNavText = styled.p`
    text-align: center;
    color: #fff;
    font-size: 0.8rem;
    margin-top: 5px;
    font-weight: 500;
    transition: all ease-in-out 0.15;
    color: ${({ active }) => (active ? '#FE45C3' : '#DDDDFA')};
`

export default BottomNav
